import * as z from "zod/v4";

export const searchProductVariants = {
  name: "searchProductVariants" as const,
  input: z.object({ query: z.string(), teamId: z.string() }),
  output: z.array(
    z.object({ variantId: z.string(), name: z.string(), imageSrc: z.string() }),
  ),
};
